import { styled } from '@mui/system';
import { ListItemText, Stack } from '@mui/material';
import { BasisRoot } from '../styles';

const SetAppointmentRoot = styled(BasisRoot,{target: 'SetAppointmentRoot'})(({theme}) => ({
  marginBottom: '3em',
  '& .BoxPanel':{
    padding: theme.spacing(2, 2),
  }
}));

const GridContainer = styled('div', {target: 'GridContainer'})(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 2fr', /* Split the grid into two columns: one with 1 part and one with 2 parts */
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1.5fr 2fr'
   },
  gridGap: '1rem',
  alignItems: 'stretch', /* Add some spacing between the columns */
  gridRowGap: 0,
  overflowX: 'clip'
}))

const GridTile = styled('div', {target: 'GridTile'})(({theme}) => ({
  "& .MuiTypography-body1": {
    fontSize: 14
  }
}))

const GridDescription = styled('div', {target: 'GridDescription'})(({theme}) => ({

}))

const StyledPrimaryTittleWrapper = styled(Stack)(({ theme }) => ({
  color: theme.vars.palette.primary.textColor,
  alignItems: 'center',
  'svg': {
    height: '16px',
    [theme.breakpoints.up('sm')]: { marginRight: theme.spacing(1) },
    color: theme.vars.palette.primary.textColor
  }
}))

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  color: theme.vars.palette.primary.textColor,
  margin: 0,
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
  fontSize: '0.875rem',
  height: 'auto',
  "& .MuiTypography-body1": {
    fontWeight: 500
  },
  "& .MuiTypography-body2": {
    fontWeight: 400
  }
}));

export {
  SetAppointmentRoot,
  StyledPrimaryTittleWrapper,
  StyledListItemText,
  GridContainer,
  GridTile,
  GridDescription
}